export const blockIconsPhotoandimageNavigateNextNew = (
	<span className='material-symbols-outlined'>navigate_next</span>
);
